import { useState } from 'react';
import { clsx } from 'clsx';

interface ActionItem {
  id: string;
  title: string;
  context: string;
  deadline?: Date;
  energyCost: 1 | 2 | 3 | 4 | 5;
  location?: string;
}

// Placeholder - will be replaced with real data
const mockAction: ActionItem = {
  id: '1',
  title: 'Set up WholeWorm development environment',
  context: 'work',
  energyCost: 3,
};

const contextColors: Record<string, string> = {
  work: 'bg-blue-500',
  legal: 'bg-purple-500',
  parenting: 'bg-green-500',
  personal: 'bg-yellow-500',
  health: 'bg-red-500',
  finance: 'bg-emerald-500',
};

export function ActionCard() {
  const [action] = useState<ActionItem | null>(mockAction);
  const [isCompleting, setIsCompleting] = useState(false);

  const handleComplete = () => {
    setIsCompleting(true);
    // TODO: Implement completion logic
    setTimeout(() => setIsCompleting(false), 1000);
  };

  const handleDefer = () => {
    // TODO: Implement defer logic
  };

  if (!action) {
    return (
      <div className="card-raised text-center py-12">
        <span className="text-5xl mb-4 block">✨</span>
        <h3 className="text-xl font-bold mb-2">All caught up!</h3>
        <p className="text-white/50">Nothing urgent right now. Take a breath.</p>
      </div>
    );
  }

  return (
    <div className="card-raised">
      {/* Context badge */}
      <div className="flex items-center gap-2 mb-4">
        <div className={clsx('w-3 h-3 rounded-full', contextColors[action.context] || 'bg-gray-500')} />
        <span className="text-sm text-white/50 capitalize">{action.context}</span>
        <div className="flex-1" />
        <div className="flex items-center gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className={clsx(
                'w-2 h-2 rounded-full',
                i < action.energyCost ? 'bg-accent-warning' : 'bg-white/10'
              )}
            />
          ))}
        </div>
      </div>

      {/* Task title */}
      <h3 className="text-xl font-semibold mb-6 text-balance">{action.title}</h3>

      {/* Action buttons */}
      <div className="flex gap-3">
        <button
          onClick={handleDefer}
          className="btn-secondary flex-1"
          disabled={isCompleting}
        >
          Later
        </button>
        <button
          onClick={handleComplete}
          className="btn-primary flex-1"
          disabled={isCompleting}
        >
          {isCompleting ? 'Done!' : 'Complete'}
        </button>
      </div>
    </div>
  );
}
